export default "__VITE_ASSET__24048941__"